import { retrieveUser, IUserStorage } from '../storage/user';
import { IUserStore } from './types';

const userStorage = retrieveUser();

export const toUserStore = ({
  userId,
  username,
  roles,
}: IUserStorage): IUserStore => ({
  loginError: '',
  userId,
  username,
  roles,
});

export const noUser: IUserStore = {
  loginError: '',
  roles: [],
  userId: '',
  username: '',
};

export const defaultStore: IUserStore = userStorage
  ? toUserStore(userStorage)
  : noUser;



// WEBPACK FOOTER //
// ./src/services/user/store.ts